var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-2"},[(_vm.$temAcessoView('ADMIN-TIPMOV-01'))?_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-trash fa-lg icon-button",attrs:{"title":"Excluir"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarExcluir()}}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }